import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spin, Alert } from "antd";
import { tokenManager } from "../../Utils";

export const AutoLoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      const authParam = searchParams.get("auth");

      if (!authParam) {
        setError("No authentication data provided.");
        return;
      }

      const decoded = JSON.parse(atob(authParam));
      const { auth_token, userData, userPermission } = decoded;

      if (!auth_token || !userData) {
        setError("Invalid authentication data.");
        return;
      }

      localStorage.setItem("isAuth", "true");
      localStorage.setItem("userId", userData.userId || "");
      localStorage.setItem("username", userData.username || "");
      localStorage.setItem("userRole", userData.userRole || "");
      localStorage.setItem(
        "userPermission",
        JSON.stringify(userPermission || []),
      );

      tokenManager.setToken(auth_token);

      navigate("/login-success", { replace: true });
    } catch (err) {
      setError("Failed to process authentication data.");
    }
  }, []);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 p-8">
        <Alert
          message="Auto Login Failed"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="flex items-center gap-3">
        <Spin size="large" />
        <span className="text-gray-500">Logging you in...</span>
      </div>
    </div>
  );
};
